import { z } from "zod";

/** Knowledge 两个只读标签，与各自真实数据来源对应。 */
export const knowledgeTabSchema = z.enum(["products", "questions"]);
export type KnowledgeTab = z.infer<typeof knowledgeTabSchema>;
